import Link from 'next/link'
import React from 'react'
import { useSession } from '@/context/Session'

export const shouldLinkToMusicApp = (
	href: string,
	isLoggedIn?: boolean
): boolean => {
	if (
		isLoggedIn &&
		(href.includes('/browse/m/') || href.includes('/playlist/'))
	) {
		return true
	}

	return false
}

export const MusicAppLink = ({
	children,
	elseFragment = false,
	href,
	...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & {
	children: React.ReactNode | React.ReactNode[]
	elseFragment?: boolean
	href: string
}): JSX.Element => {
	const { user } = useSession()
	if (shouldLinkToMusicApp(href, !!user)) {
		return (
			<Link
				href={href}
				{...props}
				passHref={elseFragment}
				legacyBehavior={elseFragment}
			>
				{children}
			</Link>
		)
	} else if (elseFragment) {
		return <React.Fragment>{children}</React.Fragment>
	} else {
		return (
			<a href={href} {...props}>
				{children}
			</a>
		)
	}
}

export default shouldLinkToMusicApp
